/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   All the analytics related static variable should be defined here
 */

import { PAGE_NAMES, SHARE_ORIGINS, TOUR_PREFERENCE_TYPES } from '@zcode/mixpanel'

const PA_TABLE = 'pa-table' // TODO remove ZUM-60493
export const HOMEPAGE = PAGE_NAMES.HOMEPAGE
export const FULL_DETAIL = PAGE_NAMES.DETAIL
export const FILTER = 'Main Filters'
export const FILTER_BAR = 'Filter Bar'
export const LIST = 'List'
export const LIST_ITEM = 'List Item'
export const LIST_ITEM_FAVORITE = 'List Item Favorite'
export const LIST_ITEM_MESSAGED = 'List Item Messaged'
export const LIST_ITEM_SEARCH_DISCOVERY = 'List Item Search & Discovery'
export const MOBILE_BOTTOM_BAR = 'MobileBottomBar'
export const MOBILE_TOP_BAR = 'MobileTopBar'
export const CAROUSEL = SHARE_ORIGINS.CAROUSEL
export const LOGIN = 'Login'
export const NAVBAR = 'Navbar'
export const GEO_LOCATION = 'Geolocation'
export const MESSAGE = 'Message'
export const MESSAGE_FIELDS = 'MessageFields'
export const MESSAGE_MODAL = 'Message Modal'
export const MULTI_LISTING_MODAL = 'Multi Listing Modal'
export const MESSAGE_INLINE = 'Message Inline'
export const MESSAGE_SIMILAR = 'MessageSimilar'
export const SIMILAR = 'SimilarListing'
export const RELATED_MULTI_MESSAGE = 'Related MM'
export const MESSAGE_CONVERSION = 'MessageConversion'
export const FAVORITE = 'Favorite'
export const PRICE_CHART = 'PriceChart'
export const MOBILE_APP_DOWNLOAD_BAR = 'Mobile download bar'
export const LOCALE_GUIDE = 'Locale Guide'
export const NO_LISTABLES = 'No Listables'
export const MARKET_PLACE = 'Marketplace'
export const OPEN_HOUSE = TOUR_PREFERENCE_TYPES.OPEN_HOUSE
export const NOTIFICATION_SETTINGS = 'Notification Settings'
export const PRESS_PAGE = 'Press Page'
export const ABOUT_PAGE = 'About Page'
export const BOOK_ACTION_SUBMITTED = 'Submitted'
export const BOOK_ACTION_UNSUBMITTED = 'Unsubmitted'
export const BOOK_ACTION_WAITLISTED = 'Waitlisted'
export const STANDARD = 'Standard'
export const PHONE = 'Phone'
export const SHARE = 'Share'
export const REPORT = 'Report'
export const REED_MORE = 'Read more'
export const SHOW_AMENITIES = 'Show all amenities'
export const CHECK_AVAILABILITY = 'Check availability'
export const SUMMARY = 'Summary'
export const SHOW_ALL_SCORES = 'Show all scores'
export const NEAR_ME = 'Near Me'
export const BLOG = 'Blog'
export const PERFORMANCE_METRICS = 'Performance Metrics'
export const NAVBAR_LIST = 'Navbar List'
export const NAVBAR_MAP = 'Navbar Map'
export const NAVBAR_ALERTS = 'Navbar Alerts'
export const NAVBAR_MESSAGED = 'Navbar Messaged'
export const NAVBAR_FAVORITES = 'Navbar Favorites'
export const CALLS = 'Calls'
export const CALL = 'Call'
export const CALL_M4 = 'Call M4'
export const CALL_M3 = 'Call M3'
export const INSTANT_APPLY = 'Instant Apply'
export const FAIR_HOUSING = 'Fair Housing'
export const PRIVACY_POLICY = 'Privacy Policy'
export const TERMS_AND_CONDITIONS = 'Terms and Condtions'
export const AFFORDABILITY_CALCULATOR = 'Affordability Calculator'
export const VIRTUAL_TOURS_PAGE = 'Virtual Tours Page'
export const PERMANENT_ADDRESS = 'Permanent Address'
export const PROGRAMMATIC_RENT = 'Programmatic Rent Report'
export const JOBS_PAGE = 'Jobs Page'
export const SHORT_TERM_RENTALS_LANDING = 'Short Term Rentals Landing'
// see sendMessageSuccess.js
export type AnalyticChannel =
  | typeof FULL_DETAIL
  | typeof LIST
  | typeof LIST_ITEM
  | typeof SIMILAR
  | typeof PA_TABLE
export const GALLERY = 'Gallery'
